import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { CoursRechercheModel } from '../../../cours/models/cours-recherche.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { SettingsService } from '../../../core/settings/settings.service';
import { TABLE } from '../../../app.constantes';
import { DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { CheckboxInputComponent } from '@ngx-resource-toolkit/core';

const pipe_professeur_libelle = { transform: (value) => value && value.nom ? value.nom + ' ' + (value.prenom ? value.prenom : '') : '' };
const pipe_places_dispo = { transform: (value) => (value.nbElevesMax ? + value.nbElevesMax : 0) - (value.nbElevesInscrits ? +value.nbElevesInscrits : 0)};
const pipe_horaire = { transform: (value) => value ? (Math.trunc(value / 60)) + ':' + (value % 60) : ''};
@Component({
  selector: 'app-search-cours-collectif',
  templateUrl: './search-cours-collectif.component.html',
  styleUrls: ['./search-cours-collectif.component.scss']
})
export class SearchCoursCollectifComponent implements OnInit, OnDestroy, OnChanges {
  // public log: string = "";
  @Input() searchModel: CoursRechercheModel;
  @Input() anneeScolaire: number;
  @Output() coursSelected = new EventEmitter<any>();
  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild('nbMaxAtteint') nbMaxAtteint;
  @ViewChild('filter') filter;
  @ViewChild('filterDiscipline') filterDiscipline;
  @ViewChild('filterCycle') filterCycle;
  @ViewChild('filterNiveau') filterNiveau;
  @ViewChild('fictif') fictif;
  public selectionType: SelectionType = SelectionType.single;
  public loadingIndicator: boolean = false;
  private sub: any;
  public rows = [];
  columns = [
    { name: 'N°', prop: 'id', minWidth: TABLE.MIN_WIDTH.ID },
    { name: 'Discipline', prop: 'disciplineLibelle' },
    { name: 'Cycle', prop: 'cycleLibelle' },
    { name: 'Niveau', prop: 'niveauLibelle' },
    { name: 'Professeur', prop: 'professeur', pipe: pipe_professeur_libelle },
    { name: 'Salle', prop: 'salleNom' },
    { name: 'Jour', prop: 'jourLibelle' },
    { name: 'Horaire', prop: 'horaireDebut', pipe: pipe_horaire },
    { name: 'Durée', prop: 'duree' },
    { name: 'Capacité', prop: 'nbElevesMax' },
    { name: 'Nb inscrits', prop: 'nbElevesInscrits' },
    { name: 'Places dispo', prop: '', pipe: pipe_places_dispo },
  ];
  constructor(
    private http: HttpClient,
    private settings: SettingsService,
  ) { }
  data = [];
  updateFilter() {
    console.log('updateFilter');
    this.loadingIndicator = true;
    const nbMaxAtteint = this.nbMaxAtteint && this.nbMaxAtteint.nativeElement ? this.nbMaxAtteint.nativeElement.checked : false;
    const val = this.filter && this.filter.nativeElement && this.filter.nativeElement.value ? this.filter.nativeElement.value.toLowerCase() : '';
    const valDiscipline = this.filterDiscipline && this.filterDiscipline.nativeElement && this.filterDiscipline.nativeElement.value ? this.filterDiscipline.nativeElement.value.toLowerCase() : '';
    const valCycle = this.filterCycle && this.filterCycle.nativeElement && this.filterCycle.nativeElement.value ? this.filterCycle.nativeElement.value.toLowerCase() : '';
    const valNiveau = this.filterNiveau && this.filterNiveau.nativeElement && this.filterNiveau.nativeElement.value ? this.filterNiveau.nativeElement.value.toLowerCase() : '';
    const fictif = this.fictif && this.fictif.nativeElement ? this.fictif.nativeElement.checked : false;
    console.log({ nbMaxAtteint: this.nbMaxAtteint.nativeElement.checked, val, fictif });
    // this.log = 'nbMaxAtteint: ' + nbMaxAtteint + " - fictif= " + fictif + " - filtre=" + val;
    // filter our data
    const dataFiltered = this.data.filter(function (d) {
      return (nbMaxAtteint ? true : +d.nbElevesMax === 0 || +d.nbElevesMax > +d.nbElevesInscrits)
        && (fictif ? true : !d.isFictif)
        && 
        (+d.id === +val
        || (d.disciplineLibelle ? d.disciplineLibelle.toLowerCase().indexOf(val) >= 0 : false)
        || (d.cycleLibelle ? d.cycleLibelle.toLowerCase().indexOf(val) >= 0 : false)
        || (d.niveauLibelle ? d.niveauLibelle.toLowerCase().indexOf(val) >= 0 : false)
        || (d.professeur && d.professeur.nom ? d.professeur.nom.toLowerCase().indexOf(val) >= 0 : false)
        || (d.salleNom ? d.salleNom.toLowerCase().indexOf(val) >= 0 : false)
        || (d.jourLibelle ? d.jourLibelle.toLowerCase().indexOf(val) >= 0 : false))
        && (valDiscipline ? d.disciplineLibelle ? d.disciplineLibelle.toLowerCase().indexOf(valDiscipline) >= 0 : false : true)
        && (valCycle ? d.cycleLibelle ? d.cycleLibelle.toLowerCase().indexOf(valCycle) >= 0 : false : true)
        && (valNiveau ? d.niveauLibelle ? d.niveauLibelle.toLowerCase().indexOf(valNiveau) >= 0 : false : true);
    });

    // update the rows
    this.rows = dataFiltered;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
    this.loadingIndicator = false;
  }

  loadData() {
    console.log('loadData');
    if (this.sub) {
      this.sub.unsubscribe();
    }
    const annee = this.anneeScolaire ? this.anneeScolaire : +this.settings.getUserSetting('anneeScolaire');
    this.loadingIndicator = true;
    this.sub = this.http.get(
      environment.proxyUrl + '/cours/findCoursCollectifWithPlaceDisponibles',
      {
        params: {
          'params': JSON.stringify([annee]),
        }
      }).subscribe(data => {
        console.log(data);
        // cache our list
        this.data = [...<Array<Object>>data];
        this.updateFilter();
        this.loadingIndicator = false;
      });

  }
  ngOnInit() {
    console.log({ ou: 'SearchCoursCollectifComponent.ngOnInit', searchModel: this.searchModel, anneeScolaire: this.anneeScolaire });
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log({ ou: 'changes', changes, anneeScolaire: this.anneeScolaire });
    if (changes.searchModel) {
      this.loadData();
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    //this.storeSelectSub.unsubscribe();
  }


  onSelect({ selected }) {
    console.log('Select Event', selected);
    this.coursSelected.emit(selected[0]);
  }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/cours/search-cours-collectif/search-cours-collectif.component.ts